import { useState, useEffect } from 'react';
import { getAddress } from '../utils/address';

export const useAddressFromCep = (cep: string) => {
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");

  useEffect(() => {
    const normalizedCep = cep?.replace(/\D/g, "");
    const isValid = normalizedCep?.length === 8;

    if (!isValid) {
      setCity("");
      setState("");
      return;
    }

    (async () => {
      const { city, state } = await getAddress(normalizedCep);
      setCity(city);
      setState(state);
    })();
  }, [cep]);

  return { city, state };
};
